import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import {
    CareerOpeningsCompWrapper,
    WhyCompWrapper,
} from "../../styles/StyledComponents/WhyCompWrapper";
import { careerCardMock } from "../../ui/json/demo.mock";
import CommonCard from "../CommonCard/CommonCard";
import CommonHeading from "../CommonHeading/CommonHeading";

const CareerOpeningsComp = () => {
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 3000,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 1.6,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1.027,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <CareerOpeningsCompWrapper className="cmn_gap_btm">
      <WhyCompWrapper>
        <div className="container">
          <CommonHeading
            className="whySec_heading"
            isPrimary
            title="Career Openings"
            paratext="Discover the exciting career opportunities with us! The Weavers team is looking for a passionate career enthusiast. Weavers Web is a career hub where your skills can give you a shining career. Join our company today!"
          />
          <div className="slider_cards_Wrap">
            <Slider {...settings}>
              {careerCardMock?.map((data, index) => (
                <div className="career_cards_col" key={index}>
                  <CommonCard
                    className="carrer_slide_Card"
                    typeofCard={"career"}
                    {...data}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </WhyCompWrapper>
    </CareerOpeningsCompWrapper>
  );
};

export default CareerOpeningsComp;
